export default __webpack_public_path__ + "static/media/silvestri-matteo-6-C0VRsagUw-unsplash.b81c9236.jpg";